//
// CodeBlock.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./CodeGroup";
import "./ModelDataSource";
import "./CodeBlockType";
import "./GeneratedColumn";
import "./ReferencedColumn";

var CodeBlock = createModule("BIRD::CodeBlock", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::CodeGroup"], EventDispatcher, [
    ,
    {
        scoreCodeNumbers: 7,
        referencedColumns: [1],
        name: 7,
        type: 4,
        generatedColumns: [1],
        modelDataSource: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default CodeBlock;
